import React from "react";
import UnderConstruction from "../components/UnderConstruction";

const NewsletterPage = () => {
  return (
    <UnderConstruction 
      title="Newsletter Signup"
      description="Stay updated with the latest conscious business insights, certification updates, and community highlights through our monthly newsletter."
      expectedLaunch="Coming Soon"
    />
  );
};

export default NewsletterPage;